import { render } from "./VideoListSortSwitch.vue?vue&type=template&id=cf54cae6&ts=true"
import script from "./VideoListSortSwitch.vue?vue&type=script&lang=ts"
export * from "./VideoListSortSwitch.vue?vue&type=script&lang=ts"

import "./VideoListSortSwitch.vue?vue&type=style&index=0&id=cf54cae6&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__